import { AppSettings } from "./interfaces/App-Settings";

// Get the deployment environment from webpack DefinePlugin
const deploymentEnv = process.env.DEPLOYMENT_ENV || 'local';

// Environment-specific API configurations
const getApiPath = (): string => {
    switch (deploymentEnv) {
        case 'local':
            return "https://localhost:44361";
        case 'development':
            return "https://api.dev-baltensperger.chili.ch";
        case 'stage':
            return "https://api.stage-baltensperger.chili.ch"; // Add staging if needed
        case 'production':
            return "https://api-baltiapp.baltensperger.ch";
        default:
            console.warn(`Unknown deployment environment: ${deploymentEnv}, defaulting to local`);
            return "https://localhost:44361";
    }
};

const appSettings: AppSettings = {
    apiPath: getApiPath(),
    forumUrl: ""
}

// Log current configuration for debugging
console.log(`App Settings - Environment: ${deploymentEnv}, API Path: ${appSettings.apiPath}`);

export default appSettings;